import { Images } from "../../images";

const Splash = () => (
	<div className="relative grid size-26 place-items-center">
		<img
			className="absolute inset-0"
			src={Images.GRATIS_BANKINTYG}
			alt="gratis bankintyg"
			aria-hidden="true"
		/>
	</div>
);

export default Splash;
